import { render } from "./CCOPatientNavigation.vue?vue&type=template&id=ba191d02&scoped=true&lang=pug"
import script from "./CCOPatientNavigation.vue?vue&type=script&lang=js"
export * from "./CCOPatientNavigation.vue?vue&type=script&lang=js"

import "./CCOPatientNavigation.vue?vue&type=style&index=0&id=ba191d02&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba191d02"]])

export default __exports__